import { render, staticRenderFns } from "./integratedTable.vue?vue&type=template&id=487de395&scoped=true&"
import script from "./integratedTable.vue?vue&type=script&lang=js&"
export * from "./integratedTable.vue?vue&type=script&lang=js&"
import style0 from "./integratedTable.vue?vue&type=style&index=0&id=487de395&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487de395",
  null
  
)

export default component.exports